interface Props {
  meters: Array<{ label: string; value: number; max: number; hint?: string }>;
}

export default function QualityMeters({ meters }: Props) {
  // Inner content only; SectionShell supplies the `quality` anchor + eyebrow.
  return (
    <div className="POST__ANALYSIS__meters">
      {meters.map((m) => {
        const pct = Math.max(0, Math.min(100, (m.value / m.max) * 100));
        return (
          <div key={m.label} className="POST__ANALYSIS__meter">
            <div className="POST__ANALYSIS__meter__top">
              <span>{m.label}</span>
              <span className="POST__ANALYSIS__meter__val">
                {Math.round(m.value)}
              </span>
            </div>
            <div className="POST__ANALYSIS__meter__track">
              <div
                className="POST__ANALYSIS__meter__fill"
                style={{ width: `${pct}%` }}
              />
            </div>
            {m.hint && <p className="POST__ANALYSIS__meter__hint">{m.hint}</p>}
          </div>
        );
      })}
    </div>
  );
}
